module.exports = __webpack_public_path__ + "img/7th-grade-en.2e71b3fb.png";